import * as stylex from '@stylexjs/stylex';
import { forwardRef } from 'react';
import { Icon, type IconProps } from '../IconShell';
import { iconsStyles } from '../styles';
export const Reworking = forwardRef<SVGSVGElement, Partial<IconProps>>(function Reworking({
  styles,
  ...props
}, ref) {
  return <Icon title="Reworking" description="A shape being modified by another shape" ref={ref} {...stylex.props(styles)} viewBox="0 0 94 94" {...props}>
        <path {...stylex.props(iconsStyles.backgroundElement)} d="M0 8a8 8 0 0 1 8-8h78a8 8 0 0 1 8 8v78a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8Z" />
        <path {...stylex.props(iconsStyles.darkElement)} d="M12.6 32a4 4 0 0 1 4-4h35.6a4 4 0 0 1 4 4v31.6a4 4 0 0 1-4 4H16.6a4 4 0 0 1-4-4V32.1Z" />
        <path {...stylex.props(iconsStyles.lightElement)} d="M44.2 50.4a4 4 0 0 1 0-6.8l25.6-15.3a4 4 0 0 1 6 3.4v30.6a4 4 0 0 1-6 3.4L44.2 50.4Z" />
      </Icon>;
});